import * as React from 'react';
import { observer } from 'mobx-react';
import cn from 'classnames';

import { urls } from 'shared/entities/domain';
import {
  useCabinetsStore,
  useCabinetStore,
  useRouterStore,
  useUiStore
} from 'stores';
import CabinetSelector from 'shared/containers/selectors/CabinetSelector';
import {
  SelectorSize,
  SelectorTriggerSize
} from 'shared/newEntities/components/Selector';

import './Cabinet.modules.scss';

type Props = {
  className?: string;
};

const Cabinet: React.FC<Props> = ({ className }) => {
  const cabinetStore = useCabinetStore();
  const cabinetsStore = useCabinetsStore();
  const routerStore = useRouterStore();
  const uiStore = useUiStore();

  const handleCabinetClick = React.useCallback(
    (domain: string | null) => {
      if (!domain) {
        return;
      }

      const isCurCabinet = cabinetStore.entity?.domain === domain;

      if (!isCurCabinet) {
        routerStore.changeSubDomain({
          subDomain: domain
        });
      } else {
        routerStore.push(urls.SETTINGS.root);
        if (uiStore.isMobileSize) {
          uiStore.menuState.close();
        }
      }
    },
    [cabinetStore.entity?.domain, uiStore.isMobileSize]
  );

  return (
    <div
      styleName={cn(!cabinetsStore.loaded && 'cabinet__selector-fixed')}
      className={className}
    >
      <CabinetSelector
        value={cabinetStore.entity?.domain ?? null}
        onChange={handleCabinetClick}
        size={SelectorSize.small}
        triggerSize={
          uiStore.isMobileSize ? SelectorTriggerSize.l : SelectorTriggerSize.sm
        }
        label={(t) =>
          t('PageTemplate.Cabinet.label', {
            ns: 'newComponents'
          })
        }
      />
    </div>
  );
};

export default observer(Cabinet);
